export default "__VITE_ASSET__CWA2ZEzG__"